import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IHideOfferWebsiteResponse200,
  type IHideOfferWebsiteResponse400,
  type THideOfferWebsiteRequest,
  type THideOfferWebsiteResponse_1,
  createHideOfferWebsiteModel,
  fetchHideOfferWebsite,
} from '@/repositories/generated/shared/hidden-objects/v1/hide-offer-website';

export function fetchAddFavoriteService(
  applicationContext: IQueryStateAppContext,
  parameters: THideOfferWebsiteRequest,
): Promise<THideOfferWebsiteResponse_1> {
  const { httpApi, logger } = applicationContext;

  const fetchAssertsService = new FetchAssertsService(
    createHideOfferWebsiteModel(parameters),
    '@/shared/store/serverSide/hidden-objects/v1/hide-offer-website/internal/fetchService.ts',
    logger,
  );

  return fetchHideOfferWebsite<IHideOfferWebsiteResponse200, IHideOfferWebsiteResponse400>({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
